import {
  postData,
  putData,
  getData
} from './request'


// 获取联系人
export function getContacts({offset,limit}, cb) {
  return getData(`/api/contacts?offset=${offset}&limit=${limit}`, {}, cb)
}

// 为文档添加权限用户权限
export function addContacts(paload, cb) {
  return postData(`/api/v3/groups/${paload.groupid}/files/${paload.fileid}/invitees`, paload,{}, cb)
}

// 搜索联系人
export function searchContacts(key, cb) {
  return getData(`/api/contacts/search?q=${encodeURIComponent(key)}`,{}, cb)
}


// WEBPACK FOOTER //
// ./src/store/service/contact.js